"use client"

import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { PazomatAdvancedMarkerIcon, useIsDesktop } from "ui";

type Props = {
  lng: number
  lat: number
  fill?: string
  onClick: () => void
  title: string
  address: string
  phone: string | undefined
  onClose: () => void
  active?: boolean
}

function PazomatAdvancedMarker({
  lng,
  lat,
  fill,
  onClick,
  onClose,
  title,
  address,
  phone,
  active,
}: Props) {
  const [markerRef, marker] = useAdvancedMarkerRef()
  const isDesktop = useIsDesktop()

  const handleClick = () => {
    onClick && onClick()
  }

  const closeInfoWindow = () => {
    onClose()
  }
  return (
    <AdvancedMarker
      ref={markerRef}
      onClick={handleClick}
      position={{ lng, lat }}
      zIndex={active ? 1000 : undefined}
    >
      <PazomatAdvancedMarkerIcon fill={fill}></PazomatAdvancedMarkerIcon>

      {isDesktop && active && title && ( // Only show if active and we have a title
        <InfoWindow anchor={marker} onCloseClick={closeInfoWindow}>
          <div
            style={{
              fontSize: 18,
              fontWeight: "500",
              lineHeight: "25.2px",
              color: "rgba(0, 80, 201, 1)",
              paddingTop: 10,
              minWidth: 200, // Ensure minimum width for readability
            }}
          >
            {title}
          </div>
          {address && <div style={{ fontSize: 14, lineHeight: "20px" }}>{address}</div>}
          {phone &&
            <div style={{ fontSize: 14, lineHeight: "20px", fontWeight: "500" }}>
              {phone}
            </div>
          }
        </InfoWindow>
      )}
    </AdvancedMarker>
  )
}

export default PazomatAdvancedMarker
